import request from "../../helpers/request";

export const getDashboardGeral = async () => {
  const url = `${process.env.REACT_APP_API}/hub/GetDashboardGeral`;
  const result = await request({ url });
  return result.data;
};
